var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20.5 10C20.5 15.5228 16.0228 20 10.5 20C4.97715 20 0.5 15.5228 0.5 10C0.5 4.47715 4.97715 0 10.5 0C16.0228 0 20.5 4.47715 20.5 10ZM3.61817 10C3.61817 13.8007 6.69927 16.8818 10.5 16.8818C14.3007 16.8818 17.3818 13.8007 17.3818 10C17.3818 6.19927 14.3007 3.11817 10.5 3.11817C6.69927 3.11817 3.61817 6.19927 3.61817 10Z",
    fill: "#F7665F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9409 10C19.802 10 20.5124 9.29783 20.3787 8.44721C20.2563 7.66837 20.0419 6.90492 19.7388 6.17317C19.2362 4.95991 18.4997 3.85752 17.5711 2.92893C16.6425 2.00035 15.5401 1.26375 14.3268 0.761205C13.5951 0.4581 12.8316 0.243716 12.0528 0.121293C11.2022 -0.0124119 10.5 0.698026 10.5 1.55908C10.5 2.42014 11.2067 3.10061 12.0458 3.29402C12.4165 3.37948 12.7804 3.49574 13.1336 3.64202C13.9685 3.98786 14.7272 4.49477 15.3662 5.13381C16.0052 5.77285 16.5121 6.5315 16.858 7.36644C17.0043 7.71959 17.1205 8.08347 17.206 8.45421C17.3994 9.29326 18.0799 10 18.9409 10Z",
    fill: "#F7665F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerRed);
export default __webpack_public_path__ + "static/media/SpinnerRed.62369293906cd0014c1d3108c63cfb9b.svg";
export { ForwardRef as ReactComponent };